/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_Pump_TitleInputs */

const vi_camera_station_pump_title = /** @type {(inputs: Camera_Station_Pump_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy bơm`)
};

/**

* @param {Camera_Station_Pump_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_pump_title = /** @type {((inputs?: Camera_Station_Pump_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_Pump_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_pump_title(inputs)
});